import script from "./DurationHistogram.vue?vue&type=script&setup=true&lang=ts"
export * from "./DurationHistogram.vue?vue&type=script&setup=true&lang=ts"

import "./DurationHistogram.vue?vue&type=style&index=0&id=0e21db44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e21db44"]])

export default __exports__